// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import { getProp } from "@insite/mobius/utilities";
import { xBaseTheme } from "@sc/XDL/types";
import { color, ellipsis } from "@sc/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        border: "rounded",
        sizeVariant: "default",
        mergeCss: true,
        labelProps: {
            mergeCss: true,
            size: 12,
            weight: 600,
            color: "common.ui7",
            css: css`
                letter-spacing: 0;
                line-height: 14px;
                min-height: initial;
                .star {
                    color: ${color("danger")};
                }
            `,
        },
        errorProps: {
            mergeCss: true,
            size: 14,
            weight: "normal",
            color: "common.ui7",
            css: css`
                letter-spacing: 0;
                line-height: 22px;
            `,
        },
        hintProps: {
            mergeCss: true,
            size: 12,
            weight: "normal",
            css: css`
                letter-spacing: 0;
                line-height: 14px;
            `,
        },
        backgroundColor: "common.white",
        cssOverrides: {
            formInputWrapper: css`
                ${IconWrapper} {
                    color: ${color("text.link")};
                }
                input,
                textarea,
                select {
                    transition: all ${getProp("theme.transition.duration.regular")}ms ease-in-out;
                    &.react-datetime-picker__inputGroup__input {
                        &__input {
                            &::placeholder {
                                font-style: normal;
                            }
                        }
                    }
                    &:not(.react-datetime-picker__inputGroup__input):not([name="datetime"]) {
                        ${ellipsis(1)}
                        text-overflow: ellipsis;
                        &:not(:disabled)::placeholder {
                            font-size: 14px;
                            line-height: 16px;
                            font-style: italic;
                            max-width: 100%;
                            color: ${color("common.ui4")};
                        }

                        &:not([class^="PopoverTriggerInput"]):hover:not(:disabled) {
                            border: 1px solid ${color("common.ui8")};
                        }
                        &:not([class^="PopoverTriggerInput"]):focus:not(:disabled) {
                            border: 1px solid ${color("common.ui9")};
                        }
                    }
                    &:disabled::placeholder {
                        font-size: 14px;
                        line-height: 16px;
                        color: ${color("common.black")};
                        font-style: italic;
                    }
                }

                input,
                textarea {
                    box-shadow: inset 0 1px 0 0 ${color("common.ui7", 0.1)};
                }

                textarea:not(.react-datetime-picker__inputGroup__input):not([name="datetime"]) {
                    overflow: auto;
                }
            `,
        },
    },
} as xBaseTheme["formField"];
